import { Observable } from "rxjs"
import { map, pluck } from "rxjs/operators"

import { PrintableReport } from "@skinsoft/types"
import { EntityDataStore } from "@skinsoft/entity-data-store"

export enum PrintableReportFormat {
    INDIVIDUAL_LABEL = 'INDIVIDUAL_LABEL'
}

export class PrintableReportDataStore extends EntityDataStore<PrintableReport> {
    public static getInstance(): PrintableReportDataStore {
        if (!PrintableReportDataStore.instance) {
            PrintableReportDataStore.instance = new PrintableReportDataStore();
        }

        return PrintableReportDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$printableReportDataStore = PrintableReportDataStore.getInstance()
    }

    private static instance: PrintableReportDataStore = null as any

    constructor() {
        super('printablereport')
    }

    protected initializeDataFetcher() {
        //throw new Error('Method not implemented.')
    }

    protected initializeDataPusher() {
        //throw new Error("Method not implemented.");
    }

    public getAllReportsOfTypesAndFormats(entities: string[], formats: PrintableReportFormat[]): Observable<PrintableReport[]> {
        return this.proxy.fetch(`${this.endpoint}/withTypes`, { entities }).pipe(
            pluck('_embedded', 'printablereports'),
            map(reports => {
                return reports.filter(report => formats.includes(report.printableReportGridList[0]?.format))
            }),
        )
    }
}